import _ from 'lodash';


const compareUtil = {
	compareStringsCaseInsensitive: (string1, string2) => {
		return _.isString(string1) && _.isString(string2)
			? string1.toUpperCase() === string2.toUpperCase()
			: false;
	},
};

module.exports = compareUtil;
